module.exports = __webpack_public_path__ + "img/servicepro_small.1a96851f.png";